import $ from 'jquery';

$(_ => {

    $('.js-renewal-change-seats').on('click', function() {
        const $el = $(this);
        const order_no = $el.attr('data-order-no');
        const pkg_no = $el.attr('data-pkg-no');
        lDialog.open({
            title: 'Change Seats',
            autofocusFirstFocusableElement: false,
            ajax: {
                url: '/h/renewals/ShowDialogChangeSeats',
                data: {
                    pkg_no: pkg_no,
                    order_no: order_no
                }
            }
        });
    });

});